import React from 'react'
import { createModalManager } from 'components/Modals'
import SettingsModal, { ISettingsModal } from 'modules/settings/SettingsModal'
import AddIntegrationModal from 'modules/integrations/AddIntegrationModal'
import TransactionModal, { ITransactionModal } from 'modules/transactions/TransactionModal'
import ConfirmModal, { IConfirmModal } from 'components/ConfirmModal'
import TutorialModal, { ITutorialModal } from 'modules/common/TutorialModal'
import CreateOrganizationModal from 'modules/organization/CreateOrganizationModal'
import InviteOrganizationMemberModal from 'modules/organization/InviteOrganizationMemberModal'
import CreateTransferModal from 'modules/transactions/CreateTransferModal'
import InviteClientModal from 'modules/clients/InviteClientModal'
import CreateWalletModal, { ICreateWalletModal } from 'modules/integrations/CreateWalletModal'
import BlockerModal, { IBlockerModal } from '../BlockerModal'

type ModalMapType =
	| ModalStateType<'settings', ISettingsModal>
	| ModalStateType<'integrations.add'>
	| ModalStateType<'clients.invite'>
	| ModalStateType<'clients.disconnect', IConfirmModal>
	| ModalStateType<'clients.reject', IConfirmModal>
	| ModalStateType<'integrations.stop', IConfirmModal>
	| ModalStateType<'integrations.disconnect', IConfirmModal>
	| ModalStateType<'integrations.disconnect.all', IConfirmModal>
	| ModalStateType<'integrations.resync', IConfirmModal>
	| ModalStateType<'transactions.remove.all', IConfirmModal>
	| ModalStateType<'transactions.add', ITransactionModal>
	| ModalStateType<'transactions.create.transfer'>
	| ModalStateType<'tutorial', ITutorialModal>
	| ModalStateType<'organization.create'>
	| ModalStateType<'organization.invite'>
	| ModalStateType<'organization.member.remove', IConfirmModal>
	| ModalStateType<'organization.invite.remove', IConfirmModal>
	| ModalStateType<'organization.leave', IConfirmModal>
	| ModalStateType<'organization.remove', IConfirmModal>
	| ModalStateType<'reports.last.analyze', IConfirmModal>
	| ModalStateType<'wallets.create', ICreateWalletModal>
	| ModalStateType<'wallets.remove', IConfirmModal>
	| ModalStateType<'wealthica.upgrade.redirect', IConfirmModal>
	| ModalStateType<'wealthica.resync', IConfirmModal>
	| ModalStateType<'blocker', IBlockerModal>

const { Provider, useShowModal } = createModalManager(({ id, params }: ModalMapType) => {
	switch (id) {
		case 'settings':
			return <SettingsModal {...(params as ISettingsModal)} />

		case 'integrations.add':
			return <AddIntegrationModal />

		case 'transactions.add':
			return <TransactionModal {...(params as ITransactionModal)} />

		case 'integrations.stop':
		case 'integrations.disconnect':
		case 'integrations.disconnect.all':
		case 'integrations.resync':
		case 'transactions.remove.all':
		case 'clients.disconnect':
		case 'clients.reject':
		case 'organization.member.remove':
		case 'organization.invite.remove':
		case 'organization.leave':
		case 'organization.remove':
		case 'reports.last.analyze':
		case 'wallets.remove':
		case 'wealthica.upgrade.redirect':
		case 'wealthica.resync':
			return <ConfirmModal {...(params as IConfirmModal)} />

		case 'tutorial':
			return <TutorialModal {...(params as ITutorialModal)} />

		case 'organization.create':
			return <CreateOrganizationModal />

		case 'organization.invite':
			return <InviteOrganizationMemberModal />

		case 'transactions.create.transfer':
			return <CreateTransferModal />

		case 'clients.invite':
			return <InviteClientModal />

		case 'wallets.create':
			return <CreateWalletModal {...(params as ICreateWalletModal)} />

		case 'blocker':
			return <BlockerModal {...(params as IBlockerModal)} />

		default:
			return null
	}
})

export { useShowModal }

export default { Provider }
